import React from "react";
import "./menuLink.scss";

const MenuLink2 = ({ Icon, text, href }) => {
  return (
    <a href={href} target="_blank" rel="noopener noreferrer" className="menuLink">
      <img src={Icon} alt="menu icon" className="menuIcon" />
      <span className="menuLinkText">{text}</span>
    </a>
  );
};

export default MenuLink2;
